const BATCH_MOVE_CONFIRMATION_THRESHOLD = 50;
const UNLOCATED_LABEL = "Unlocated";

const needsBatchMoveConfirmation = itemCount =>
  itemCount > BATCH_MOVE_CONFIRMATION_THRESHOLD;

const getFromLocationNames = warehouseItems => [
  ...new Set(
    warehouseItems.map(
      warehouseItem =>
        warehouseItem?.itemSite?.location?.description || UNLOCATED_LABEL,
    ),
  ),
];

const joinWithAnd = names =>
  names.length <= 1
    ? names.join("")
    : `${names.slice(0, -1).join(", ")} and ${names[names.length - 1]}`;

const buildBatchMoveWarning = ({
  fromLocationNames = [],
  itemCount,
  toLocationName,
}) =>
  `You are about to move ${itemCount} items from ${joinWithAnd(fromLocationNames)} to ${toLocationName}, this operation cannot be reversed.`;

export {
  BATCH_MOVE_CONFIRMATION_THRESHOLD,
  buildBatchMoveWarning,
  getFromLocationNames,
  joinWithAnd,
  needsBatchMoveConfirmation,
};
